export enum TicketEventTypes {
    TodayTicketCreated = "todayTicketCreated",
    TodayTicketUpdated = "todayTicketUpdated",
    TodayTicketRankUpdated = "todayTicketRankUpdated",
    TodayTicketDeleted = "todayTicketDeleted",
    TicketsUpdated = "ticketsUpdated"
}
